import { apiSlice } from './apiSlice';

const ROLLING_ROSTER_URL = '/api/rolling-roster';

export const rollingRosterApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create 6-week rolling roster
    createRollingRoster: builder.mutation({
      query: (data) => ({
        url: `${ROLLING_ROSTER_URL}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['RollingRoster']
    }),
    
    // Get all rolling rosters
    getRollingRosters: builder.query({
      query: ({ page = 1, limit = 20, employeeId, startDate, isActive = true }) => ({
        url: `${ROLLING_ROSTER_URL}`,
        params: { page, limit, employeeId, startDate, isActive }
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({ type: 'RollingRoster', id: _id })),
              { type: 'RollingRoster', id: 'LIST' },
            ]
          : [{ type: 'RollingRoster', id: 'LIST' }],
      keepUnusedDataFor: 5
    }),
    
    // Get single rolling roster
    getRollingRosterById: builder.query({
      query: (id) => ({
        url: `${ROLLING_ROSTER_URL}/${id}`
      }),
      providesTags: (result, error, id) => [{ type: 'RollingRoster', id }]
    }),
    
    // Update rolling roster
    updateRollingRoster: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${ROLLING_ROSTER_URL}/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'RollingRoster', id },
        { type: 'RollingRoster', id: 'LIST' }
      ]
    }),
    
    // Generate availabilities from rolling roster
    generateAvailabilities: builder.mutation({
      query: ({ id, createdBy }) => ({
        url: `${ROLLING_ROSTER_URL}/generate-availabilities/${id}`,
        method: 'POST',
        body: { createdBy }
      }),
      invalidatesTags: ['Availability', 'RollingRoster']
    }),
    
    // Delete rolling roster
    deleteRollingRoster: builder.mutation({
      query: (id) => ({
        url: `${ROLLING_ROSTER_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: 'RollingRoster', id: 'LIST' }]
    }),

     // Set next generation date
    setNextGenerationDate: builder.mutation({
      query: ({ id, nextStartDate }) => ({
        url: `${ROLLING_ROSTER_URL}/${id}/set-next-date`,
        method: 'PUT',
        body: { nextStartDate }
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'RollingRoster', id },
        { type: 'RollingRoster', id: 'LIST' }
      ]
    }),
    
    // Add this mutation
updateRollingRosterPeriod: builder.mutation({
  query: ({ id, newStartDate }) => ({
    url: `${ROLLING_ROSTER_URL}/${id}/update-period`,
    method: 'PUT',
    body: { newStartDate }
  }),
  invalidatesTags: (result, error, { id }) => [
    { type: 'RollingRoster', id },
    { type: 'RollingRoster', id: 'LIST' }
  ]
}),

    // Generate availabilities for specific period
    generateAvailabilitiesForPeriod: builder.mutation({
      query: ({ id, startDate, createdBy }) => ({
        url: `${ROLLING_ROSTER_URL}/generate-period/${id}`,
        method: 'POST',
        body: { startDate, createdBy }
      }),
      invalidatesTags: ['Availability', 'RollingRoster']
    })
  
  })
});



export const {
  useCreateRollingRosterMutation,
  useGetRollingRostersQuery,
  useGetRollingRosterByIdQuery,
  useUpdateRollingRosterMutation,
  useGenerateAvailabilitiesMutation,
  useUpdateRollingRosterPeriodMutation, // Add this
  useGenerateAvailabilitiesForPeriodMutation,  // Add this
  useSetNextGenerationDateMutation,             // Add this
  useDeleteRollingRosterMutation
} = rollingRosterApiSlice;